import { Actions } from "../Actions/Actiontypes";

const initialState = {
  records: {},
};

const TeamPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SET_RECORDS:
      return {
        ...state,
        records: { ...state.records, ...action.payload },
      };
    case Actions.RESET_TEAM_PLAN:
      return initialState;
    default:
      return state;
  }
};

export default TeamPlanReducer;
